/**
 * @file constants/version.js
 * @description AUTO-GENERATED from package.json "version" by scripts/sync-version.js.
 * Do not edit by hand — bump the "version" field in package.json instead.
 */

export const APP_VERSION = "1.093";
